import React from 'react';
import TwoFactorAuthContainer from "../containers/TwoFactorAuthContainer";
import LoginFooter from "../components/LoginFooter";
import "../../styles/LoginForm.css";

export default function TwoFactorAuth() {
    return (
        <div className={"login"}>
            <div className={"login__layout"}>
                <TwoFactorAuthContainer />
                <LoginFooter />
            </div>
        </div>
    );
}
